<app-alert [type]="type" [withCloseIcon]="withCloseIcon">
  {{ message | translate }}
</app-alert>
